import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import './Projects.css';

const fullUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${process.env.REACT_APP_API_URL}${path}`;
};

const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/projects/`)
      .then(response => response.json())
      .then(data => setProjects(data))
      .catch(error => {
        console.error('Error fetching projects:', error);
        setProjects([
          {
            id: 1,
            title: 'KK Engineering Website',
            description: 'Official company website for KK Engineering Pvt. Ltd. Built with Django backend featuring dynamic service pages, admin panel, and SEO-friendly structure. Includes server deployment and maintenance.',
            technologies: 'Python, Django, HTML5, CSS3, JavaScript, PostgreSQL',
            technologies_list: ['Python', 'Django', 'HTML5', 'CSS3', 'JavaScript', 'PostgreSQL'],
            github_url: 'https://github.com/username/kk-engineering',
            live_url: 'https://kk-engineering.org',
            image: null,
            featured: true,
            order: 1
          },
          {
            id: 2,
            title: 'DEAN Organization Website',
            description: 'Dynamic organizational website for Diploma Engineering Association of Nepal using Laravel. Features backend modules, content management system, and responsive design across all devices.',
            technologies: 'PHP, Laravel, MySQL, Bootstrap, JavaScript',
            technologies_list: ['PHP', 'Laravel', 'MySQL', 'Bootstrap', 'JavaScript'],
            github_url: 'https://github.com/username/dean-website',
            live_url: 'https://deannepalregistration.com',
            image: null,
            featured: true,
            order: 2
          },
          {
            id: 3,
            title: 'Spiral Engineering Consultancy',
            description: 'Multi-page consultancy website with Django backend functionality. Implements custom models, service modules, and admin-side management tools with optimized performance.',
            technologies: 'Python, Django, React, PostgreSQL, CSS3',
            technologies_list: ['Python', 'Django', 'React', 'PostgreSQL', 'CSS3'],
            github_url: null,
            live_url: 'https://spiral-engineering.com',
            image: null,
            featured: true,
            order: 3
          },
        ]);
      });
  }, []);

  // Build JSON-LD for projects
  const projectsSchema = projects.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Pariwartan Sharma's Projects",
    "itemListElement": projects.map((project, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "SoftwareApplication",
        "name": project.title,
        "description": project.description,
        "url": project.live_url || undefined,
        "applicationCategory": "WebApplication",
        "author": {
          "@type": "Person",
          "name": "Pariwartan Sharma"
        }
      }
    }))
  } : null;

  return (
    <section id="projects" className="section projects" aria-label="Projects section">
      {projectsSchema && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(projectsSchema)}</script>
        </Helmet>
      )}
      <div className="container">
        <h2 className="section-title">Featured Projects</h2>

        <div className="projects-grid">
          {projects.map((project) => (
            <div
              key={project.id}
              className={`project-card ${project.featured ? 'featured' : ''}`}
            >
              <div className="project-image">
                <img
                  src={fullUrl(project.image) || 'https://placehold.co/400x250/1a1a1a/ffffff?text=Project'}
                  alt={`${project.title} - project screenshot`}
                  loading="lazy"
                  onError={(e) => { e.target.src = 'https://placehold.co/400x250/1a1a1a/ffffff?text=Project'; }}
                />
                <div className="project-overlay">
                  <div className="project-links">
                    {project.github_url && (
                      <a
                        href={project.github_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link"
                        aria-label={`${project.title} GitHub`}
                      >
                        <FaGithub />
                      </a>
                    )}
                    {project.live_url && (
                      <a
                        href={project.live_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link"
                        aria-label={`${project.title} live site`}
                      >
                        <FaExternalLinkAlt />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>

                <div className="project-technologies">
                  {(project.technologies_list || project.technologies.split(',')).map((tech, i) => (
                    <span key={i} className="tech-tag">{tech.trim()}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
